import { Color } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const pdfStyles = StyleSheet.create({
  page: {
    padding: 20,
    color: Color.Black,
    fontSize: 9,
  },
})
